import React from 'react';
import { Typography, Container, Paper, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next'; // Import useTranslation
import EngineeringIcon from '@mui/icons-material/Engineering';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import StoreIcon from '@mui/icons-material/Store';
import AssignmentIcon from '@mui/icons-material/Assignment';
import BuildIcon from '@mui/icons-material/Build';
import HandymanIcon from '@mui/icons-material/Handyman';
import RestoreIcon from '@mui/icons-material/Restore';
import BusinessIcon from '@mui/icons-material/Business';
import './App.css';

const About = () => {
  const { t } = useTranslation(); // Use useTranslation hook

  const services = [
    { icon: <EngineeringIcon style={{ fontSize: '40px', color: '#576a89', }} />, text: t('Engineering Services') },
    { icon: <HomeWorkIcon style={{ fontSize: '40px', color: '#576a89' }} />, text: t('Construction of Residential Buildings (including villas)') },
    { icon: <StoreIcon style={{ fontSize: '40px', color: '#576a89' }} />, text: t('Construction of Non-Residential Buildings (including supermarkets and commercial spaces)') },
    { icon: <AssignmentIcon style={{ fontSize: '40px', color: '#576a89' }} />, text: t('Feasibility Studies for Technical Projects') },
    { icon: <BuildIcon style={{ fontSize: '40px', color: '#576a89' }} />, text: t('Structural Design of Load-Bearing Structures') },
    { icon: <HandymanIcon style={{ fontSize: '40px', color: '#576a89' }} />, text: t('Technical Consultancy Services') },
    { icon: <RestoreIcon style={{ fontSize: '40px', color: '#576a89' }} />, text: t('Renovation of Buildings') },
    { icon: <RestoreIcon style={{ fontSize: '40px', color: '#576a89' }} />, text: t('Restoration of Historic Buildings') },
    { icon: <BusinessIcon style={{ fontSize: '40px', color: '#576a89' }} />, text: t('Industrial Building Renovations') },
  ];

  return (
    <Container maxWidth="lg" sx={{ py: 3 }}>
      {/* .home-paper class supplies padding/radius/shadow */}
      <Paper elevation={3} className="home-paper">
        {/* h4 typography (font, color, size) inherited from MUI theme */}
        <Typography variant="h4" align="center" sx={{ mb: 1, textUnderlineOffset: '6px' }}>
          {t('About us')}
        </Typography>

        <Typography
          variant="body1"
          align="center"
          sx={{ mt: 3, mb: 4 }}
        >
          {t('plhrofories')}
        </Typography>

        <Grid container spacing={3} justifyContent="center">
          {services.map((service, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <div style={{ textAlign: 'center', padding: 8, marginTop: 32 }}>
                {service.icon}
                <Typography
                  variant="body1"
                  sx={{ color: 'primary.main' }}
                >
                  {service.text}
                </Typography>
              </div>
            </Grid>
          ))}
        </Grid>
      </Paper>
    </Container>
  );
};

export default About;
